<template>
  <div class="base-height_fullscreen">
    <div class="base-flex base-width_fullscreen base-flex__between base-margin__bottom-10">
      <el-button type="primary" @click="describeImages">{{ $t('common.refresh') }}</el-button>
      <el-select v-model="region" :placeholder="$t('computingCluster.imagesManage.selectRegion')"
                 class="base-width__240"
                 @change="describeImages">
        <el-option v-for="item in regionList" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!--<el-button type="primary" @click="batchDestruction">批量销毁</el-button>-->
    </div>
    <el-table v-loading="tableLoading" :data="tableData" class="image_table">
      <!--<el-table-column-->
      <!--  type="selection"-->
      <!--  width="55">-->
      <!--</el-table-column>-->
      <!-- 镜像ID列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.imageId')" prop="ImageId"
                       width="180"></el-table-column>
      <!-- 镜像名称列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.imageName')" prop="ImageName"></el-table-column>
      <!-- 镜像大小列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.imageSize')" prop="ImageSize"
                       width="100"></el-table-column>
      <!-- 镜像来源列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.imageSource')" prop="ImageSource"
                       width="200"></el-table-column>
      <!-- 镜像类型列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.imageType')" prop="ImageType"
                       width="180"></el-table-column>
      <!-- 操作系统名称列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.osName')" prop="OsName" width="320"></el-table-column>
      <!-- 平台列，使用国际化标签 -->
      <!--<el-table-column :label="$t('computingCluster.imagesManage.platform')" prop="Platform"-->
      <!--                 width="120"></el-table-column>-->
      <!-- 镜像状态列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.imageState')" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.ImageState === 'NORMAL'" class="base-color__lightGreen"> {{
              scope.row.ImageState
            }}</span>
          <span v-else> {{ scope.row.ImageState }}</span>
        </template>
      </el-table-column>
      <!-- 创建时间列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.createTime')"
                       width="180">
        <template slot-scope="scope">
          {{ processISO8601Time(scope.row.CreatedTime) }}
        </template>
      </el-table-column>
      <!-- 操作列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.imagesManage.operation')" width="200">
        <template slot-scope="scope">
          <el-button :disabled="scope.row.ImageState !== 'NORMAL'" size="small" type="text"
                     @click.native.prevent="copyRowImages(scope.row)">
            {{ $t('computingCluster.imagesManage.CrossRegionReplication') }}
          </el-button>
          <el-button :disabled="scope.row.ImageState !== 'NORMAL'" size="small" type="text"
                     @click.native.prevent="deleteRowImages(scope.row)">
            {{ $t('computingCluster.imagesManage.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      :page-size="10"
      :page-sizes="[10, 20, 50, 100]"
      :total="tableDataTotal"
      align="right"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="onCurrentChange"
    >
    </el-pagination>

    <!-- 复制镜像弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('computingCluster.imagesManage.CrossRegionReplication')"
      :visible.sync="copyImageDialogVisible"
      width="600px"
    >
      <div>
        <el-form :model="imageForm" label-width="140px">
          <!--<el-form-item :label="$t('computingCluster.imagesManage.defaultRegion')">-->
          <!--  <el-select v-model="region"-->
          <!--             :placeholder="$t('computingCluster.imagesManage.selectRegion')"-->
          <!--             class="base-width__300"-->
          <!--             disabled-->
          <!--  >-->
          <!--    <el-option v-for="item in regionList" :key="item.value" :disabled="item === region"-->
          <!--               :label="item.label"-->
          <!--               :value="item.value"></el-option>-->
          <!--  </el-select>-->
          <!--</el-form-item>-->
          <el-form-item :label="$t('computingCluster.imagesManage.destinationRegions')">
            <el-select v-model="imageForm.destinationRegions"
                       :placeholder="$t('computingCluster.imagesManage.selectDestinationRegions')"
                       class="base-width__300"
                       multiple
            >
              <el-option v-for="item in regionList" :key="item.value" :disabled="item.value === region"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('computingCluster.imagesManage.imageName')">
            <div>
              <el-input v-model="imageForm.imageName" :placeholder="$t('computingCluster.imagesManage.selectImage')"
                        class="base-width__300"
                        maxlength="60"></el-input>
              <div class="base-color__grey base-font-size__12px base__line-height-20">
                {{ $t('computingCluster.imagesManage.tipsImageName') }}
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="copyImageDialogVisible = false">{{ $t('common.cancel') }}</el-button>
    <el-button
      :loading="testSyncImagesLoading"
      @click="testSyncImages"
    >
      {{ $t('customCluster.addInstanceDialog.validateParams') }}
    </el-button>
    <el-button :loading="confirmCopyImageLoading" type="primary" @click="confirmCopyImage">
      {{ $t('common.confirm') }}
    </el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {postRequest} from '@/common/libs/request';
import {processISO8601Time, regionList} from '@/common/utils/utils';
import {mapGetters, mapState} from "vuex";

export default {
  name: 'imageManagement',
  props: {
    createImageDetail: Object
  },
  data() {
    return {
      tableData: [],
      tableDataTotal: 0, // 任务总数
      tableLoading: false,
      region: 'ap-nanjing',
      regionList,
      currentPage: 1,
      pageSize: 10,
      describeImagesList: [],
      processISO8601Time,
      projectId: JSON.parse(sessionStorage.getItem('currentProject')).id || 0, // 当前项目ID
      copyImageDialogVisible: false, // 复制镜像弹窗
      imageForm: {
        imageName: '',
        destinationRegions: [],
        imageIds: []
      },
      testSyncImagesLoading: false, // 测试同步镜像
      confirmCopyImageLoading: false, // 确定同步镜像
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      this.region = currentProject?.masterNode?.region || 'ap-nanjing';
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
        this.describeImages();
      }
    },
  },

  mounted() {
    if (this.createImageDetail.region === '') {
      const currentProject = this.getCurrentProject();
      this.region = currentProject?.masterNode?.region || 'ap-nanjing';
    } else {
      this.region = this.createImageDetail.region;
    }
    this.describeImages();
  },

  methods: {
    // js函数
    // 获取镜像列表
    describeImages() {
      this.tableLoading = true;
      const params = {
        region: this.region,
        imageTypeList: ['PRIVATE_IMAGE'],
        tags: [`openeda:project-${this.projectId}`],
      };
      postRequest('/api/eda/common/tencentcloud/describeImages', params)
        .then((res) => {
          this.describeImagesList = res.imageSet || [];
          this.tableDataTotal = res.totalCount || 0;
          this.vuePagination();
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // // 多选框
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },

    // 复制镜像
    copyRowImages(row) {
      this.imageForm.imageName = row.ImageName;
      this.imageForm.imageIds = [row.ImageId];
      this.imageForm.destinationRegions = [];
      this.copyImageDialogVisible = true;
    },

    // 测试同步镜像
    testSyncImages() {
      if (!this.validateImageForm()) return;
      this.testSyncImagesLoading = true;
      const params = {
        ...this.imageForm,
        region: this.region,
        dryRun: true
      };
      postRequest('/api/eda/common/tencentcloud/syncImage', params)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('computingCluster.imagesManage.testSyncSuccess'),
          });
          this.testSyncImagesLoading = false;
        })
        .catch(() => {
          this.testSyncImagesLoading = false;
        });
    },

    validateImageForm() {
      if (this.imageForm.destinationRegions.length === 0) {
        this.$message.warning(this.$t('computingCluster.imagesManage.selectDestinationRegions'));
        return false;
      }
      if (!this.imageForm.imageName) {
        this.$message.warning(this.$t('computingCluster.imagesManage.selectImage'));
        return false;
      }

      return true;
    },

    // 确定同步镜像
    confirmCopyImage() {
      if (!this.validateImageForm()) return;
      this.confirmCopyImageLoading = true;
      const params = {
        ...this.imageForm,
        region: this.region,
        dryRun: false
      };
      postRequest('/api/eda/common/tencentcloud/syncImage', params)
        .then(() => {
          this.$notify({
            title: `${this.$t('computingCluster.imagesManage.CrossRegionReplication')} ${this.$t('common.success')}`,
            message: this.$t('computingCluster.imagesManage.crossRegionReplicationImageSuccess'),
            type: 'success'
          });
          this.confirmCopyImageLoading = false;
          this.copyImageDialogVisible = false;
        })
        .catch(() => {
          this.confirmCopyImageLoading = false;
        });
    },

    // 删除镜像
    deleteRowImages(row) {
      this.$confirm(this.$t('computingCluster.imagesManage.confirmDelete'), this.$t('computingCluster.imagesManage.tip'), {
        confirmButtonText: this.$t('computingCluster.imagesManage.confirm'),
        cancelButtonText: this.$t('computingCluster.imagesManage.cancel'),
        type: 'warning',
      }).then(() => {
        this.tableLoading = true;
        const params = {
          region: this.region,
          imageIds: [row.ImageId],
        };
        postRequest('/api/eda/common/tencentcloud/deleteImage', params)
          .then(() => {
            this.$message({
              type: 'success',
              message: this.$t('computingCluster.imagesManage.deleteSuccess'),
            });
            this.describeImages();
          })
          .catch(() => {
            this.tableLoading = false;
          });
      });
    },


    /**
     * 分页器钩子函数 页数修改时触发
     */
    onCurrentChange(page) {
      this.currentPage = page;
      this.vuePagination();
    },

    // 前端分页
    vuePagination() {
      // allData为全部数据，tableData是目前表格绑定的数据
      this.tableData = this.describeImagesList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.vuePagination();
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.image_table {
  height: calc(100% - 120px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
}

.pagination {
  padding: 20px 10px;
  background: #fff;
  text-align: right;

  ::v-deep .el-pagination__total {
    float: left;
  }
}
</style>
